
export const GA_CATEGORY = 'Verkkokauppa'
export enum GA_ACTION {
    ACCORDION = 'Accordion',
    ORDER = 'Order'
}